import { useModuleStore } from '@/stores/module-store';

/**
 * Hook to access the active SaaS (CRM) module
 */
export function useSaaSModule() {
  const saasModule = useModuleStore((s) => s.saasModule);
  const loading = useModuleStore((s) => s.saasLoading);
  const error = useModuleStore((s) => s.saasError);

  return {
    module: saasModule,
    loading,
    error,
    isLoaded: !!saasModule,
  };
}
